import React from 'react';
import './our-services.css'; 
import { FaLaptopCode, FaHandshake, FaChartLine, FaShieldAlt, FaNetworkWired, FaUsers } from 'react-icons/fa';

const OurServices = () => {
  const services = [
    { 
      icon: <FaLaptopCode />, 
      title: "Comprehensive Lending Platforms", 
      description: "Secure digital lending platforms supporting multiple partner brands and loan products." 
    },
    { 
      icon: <FaHandshake />, 
      title: "Strategic Growth Partnerships", 
      description: "Collaborative growth models designed to expand market reach across partners." 
    },
    { 
      icon: <FaChartLine />, 
      title: "Risk & Insights Management", 
      description: "Data-driven insights to support informed lending decisions." 
    },
    { 
      icon: <FaShieldAlt />, 
      title: "Regulatory Compliance Solutions", 
      description: "Frameworks ensuring KYC, data privacy, and responsible lending standards." 
    },
    { 
      icon: <FaNetworkWired />, 
      title: "NBFC & Partner Network Oversight", 
      description: "Coordinating and enabling seamless collaboration across multiple NBFCs and lending partners." 
    },
    { 
      icon: <FaUsers />, 
      title: "Seamless Client Onboarding", 
      description: "Streamlined, secure onboarding backed by responsive support teams." 
    },
  ];

  return (
   <section id="our-services" className="our-services-section data-flow-bg">
      <div className="container py-4 py-md-5">
        
        {/* Section Heading */}
        <header className="text-center mb-4 mb-md-5">
          <h2 className="display-3 fw-bold mb-3 text-primary-dark">
            Our Core Capabilities
          </h2>
          <p className="lead text-secondary-dark mx-auto" style={{ maxWidth: '800px' }}>
            Delivering secure, compliant, and scalable solutions across our fintech ecosystem.
          </p>
        </header>

        {/* Asymmetrical Split Card Container */}
        <div className="row justify-content-center g-4"> 
          {services.map((service, index) => (
            <div key={index} className="col-lg-4 col-md-6 d-flex"> 
              <div 
                className="asymmetrical-split-card w-100" 
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Skewed Icon Header */}
                <div className="card-top-skewed">
                  <div className="icon-skew-box">
                    {service.icon}
                  </div>
                </div>
                
                {/* Main Content */}
                <div className="card-bottom-content">
                  <h3 className="skew-title fw-bold text-primary-dark">
                    {service.title}
                  </h3>
                  <p className="skew-description text-secondary-dark mb-0">
                    {service.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OurServices;
